<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { ElConfigProvider } from "element-plus";
import en from "element-plus/es/locale/lang/en";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import ContactQrDialog from "@/components/ContactQrDialog/index.vue";
import MarketingFooter from "@/components/MarketingFooter/index.vue";

const { locale } = useI18n();
const route = useRoute();
const elLocale = computed(() => (locale.value === "en-US" ? en : zhCn));
const showMarketingFooter = computed(() => route.meta.layout === "marketing");
</script>

<template>
  <el-config-provider :locale="elLocale">
    <RouterView />
    <MarketingFooter v-if="showMarketingFooter" />
    <ContactQrDialog />
  </el-config-provider>
</template>

<style scoped lang="scss"></style>
